import {ThreadPrimitive} from '@assistant-ui/react';
import {Banner, Icon} from '@wandb/components';
import React, {type FC} from 'react';

import {WBAgentComposer} from './WBAgentComposer';
import {AssistantMessage, UserMessage} from './WBAgentMessage';

export const WBAgentThread: FC<{
  showOpenProjectBanner: boolean;
  disableComposerSend: boolean;
}> = ({showOpenProjectBanner, disableComposerSend}) => {
  return (
    <ThreadPrimitive.Root
      className="flex flex-1 min-h-0 flex-col"
      style={{
        ['--thread-max-width' as string]: '44rem',
      }}>
      {showOpenProjectBanner ? (
        <Banner size="sm" isDismissible={false} ml={7} mr={8} mt={5} mb={4}>
          <span>
            <strong>Open a project</strong> to use the W&B agent.
          </span>
        </Banner>
      ) : null}
      <ThreadPrimitive.Viewport
        turnAnchor="top"
        autoScroll
        className="flex flex-1 flex-col overflow-y-auto scroll-smooth px-24 pt-12 [scrollbar-gutter:stable] [scrollbar-width:thin] [scrollbar-color:#0d0f1252_transparent]">
        <ThreadPrimitive.Empty>
          <div className="flex flex-1 justify-center items-center gap-8">
            <Icon
              aria-label="workspace-agent-logo"
              icon="lightboard-solid"
              color="teal"
            />
            <span className="text-center text-[20px] font-semibold">
              {' '}
              How can I help you today?
            </span>
          </div>
        </ThreadPrimitive.Empty>
        <div className="flex flex-col shrink-0">
          <ThreadPrimitive.Messages
            components={{
              UserMessage,
              AssistantMessage,
            }}
          />
        </div>
      </ThreadPrimitive.Viewport>
      <div className="px-24 py-16">
        <WBAgentComposer disableComposerSend={disableComposerSend} />
      </div>
    </ThreadPrimitive.Root>
  );
};
